"use strict";
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    authenticityToken: function authenticityToken() {
        var token = document.querySelector('meta[name="csrf-token"]');
        if (token && _instanceof(token, window.HTMLMetaElement)) {
            return token.content;
        }
        return null;
    },
    authenticityHeaders: function authenticityHeaders(otherHeaders) {
        if (otherHeaders === void 0) {
            otherHeaders = {};
        }
        return Object.assign(otherHeaders, {
            'X-CSRF-Token': this.authenticityToken(),
            'X-Requested-With': 'XMLHttpRequest'
        });
    }
};
